import React, { useState } from 'react';
import { supabase } from '../supabase';

function UsernameSetupModal({ user, onComplete, colors, fonts }) {
  const [username, setUsername] = useState("");
  const [birthdate, setBirthdate] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async () => {
    if (!username || !birthdate) {
      setError("Please fill in all fields");
      return;
    }

    // Check age (COPPA compliance)
    const birth = new Date(birthdate);
    const today = new Date();
    const age = today.getFullYear() - birth.getFullYear();
    const monthDiff = today.getMonth() - birth.getMonth();
    const actualAge = monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate()) 
      ? age - 1 
      : age;

    if (actualAge < 13) {
      setError("You must be at least 13 years old to use The Single Loop.");
      return;
    }

    setLoading(true);
    setError(null);

    // Save profile to Supabase
    const { error: profileError } = await supabase
      .from('profiles')
      .insert([
        {
          id: user.id,
          username: username.trim(),
          birthdate: birthdate
        }
      ]);

    if (profileError) {
      setError(profileError.message);
      setLoading(false);
    } else {
      onComplete();
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0, left: 0, right: 0, bottom: 0,
        background: "rgba(0,0,0,0.85)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 10001,
        padding: "2rem"
      }}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: "20px",
          maxWidth: "480px",
          width: "100%",
          padding: "3rem",
          fontFamily: fonts.body,
          textAlign: "center"
        }}
      >
        <div style={{ fontSize: "3.5rem", marginBottom: "1rem" }}>👋</div>
        
        <h2 style={{
          fontSize: "2rem",
          fontFamily: fonts.display,
          color: colors.charcoal,
          marginBottom: "0.5rem"
        }}>
          Welcome to The Single Loop!
        </h2>
        
        <p style={{
          color: colors.darkGray,
          marginBottom: "2rem",
          lineHeight: "1.6"
        }}>
          Let's set up your profile so you can save patterns and track your projects.
        </p>

        {/* Username */}
        <div style={{ marginBottom: "1.5rem", textAlign: "left" }}>
          <label style={{
            display: "block",
            marginBottom: "0.5rem",
            fontWeight: "600",
            color: colors.brownGray,
            fontSize: "0.9rem"
          }}>
            Choose a Username
          </label>
          <input
            type="text"
            placeholder="yarnlover42"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            maxLength={20}
            style={{
              width: "100%",
              padding: "0.875rem 1rem",
              border: `2px solid ${colors.borderGreige}`,
              borderRadius: "10px",
              fontSize: "1rem",
              fontFamily: fonts.body,
              outline: "none",
              boxSizing: "border-box"
            }}
          />
        </div>

        {/* Birthdate */}
        <div style={{ marginBottom: "1.5rem", textAlign: "left" }}>
          <label style={{
            display: "block",
            marginBottom: "0.5rem",
            fontWeight: "600",
            color: colors.brownGray,
            fontSize: "0.9rem"
          }}>
            Your Birthdate
          </label>
          <input
            type="date"
            value={birthdate}
            onChange={(e) => setBirthdate(e.target.value)}
            max={new Date().toISOString().split('T')[0]}
            style={{
              width: "100%",
              padding: "0.875rem 1rem",
              border: `2px solid ${colors.borderGreige}`,
              borderRadius: "10px",
              fontSize: "1rem",
              fontFamily: fonts.body,
              outline: "none",
              boxSizing: "border-box"
            }}
          />
          <p style={{
            fontSize: "0.8rem",
            color: colors.brownGray,
            marginTop: "0.5rem",
            margin: "0.5rem 0 0 0"
          }}>
            You must be 13+ to use this site (COPPA compliance)
          </p>
        </div>

        {error && (
          <p style={{
            color: colors.dustyRust,
            fontSize: "0.9rem",
            marginBottom: "1rem",
            padding: "0.75rem",
            background: `${colors.dustyRust}15`,
            borderRadius: "8px"
          }}>
            {error}
          </p>
        )}

        <button
          onClick={handleSubmit}
          disabled={loading || !username || !birthdate}
          style={{
            width: "100%",
            padding: "1rem",
            background: loading || !username || !birthdate ? colors.borderGreige : colors.sageGreen,
            color: "#fff",
            border: "none",
            borderRadius: "10px",
            fontSize: "1rem",
            fontWeight: "600",
            cursor: loading || !username || !birthdate ? "not-allowed" : "pointer",
            fontFamily: fonts.body,
            transition: "all 0.2s"
          }}
        >
          {loading ? "Creating your profile..." : "Get Started!"}
        </button>
      </div>
    </div>
  );
}

// ========================================
// MY PROJECTS DASHBOARD COMPONENT
// ========================================



export default UsernameSetupModal;
